import { aoExibirPagina, config, url } from './config';
import { obterUsuario, avisarLogin } from './usuario';
import { enviarJson } from './api';
import { avisarErro } from './aviso';

// Terceiros fora do caminho crítico: o GA4 depois do load. O Pixel da Meta não entra no candidato (só no B2B).
// O HandTalk (Libras) é a aba do _HandTalk.cshtml, que só baixa o plugin no clique.
function _carregarScript(src, aoCarregar) {
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (aoCarregar) {
        s.addEventListener('load', aoCarregar);
    }
    document.head.appendChild(s);
}

function _depoisDoLoad(funcao) {
    if (document.readyState === 'complete') {
        funcao();
    } else {
        window.addEventListener('load', funcao, { once: true });
    }
}

function _ga(id) {
    // O gtag() e o dataLayer já existem desde o <head> (_LayoutV2): eventos enviados antes ficam na fila.
    _depoisDoLoad(() => _carregarScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`));
}

// One Tap para o visitante, no mesmo endpoint do login do v1.
function _oneTap(google) {
    _depoisDoLoad(async () => {
        const usuario = await obterUsuario();
        if (usuario.logado) {
            return;
        }

        _carregarScript('https://accounts.google.com/gsi/client', () => {
            if (!window.google?.accounts?.id) {
                return;
            }
            window.google.accounts.id.initialize({
                client_id: google.clientId,
                callback: _validarGoogle,
                cancel_on_tap_outside: false,
                itp_support: true,
                use_fedcm_for_prompt: true
            });
            window.google.accounts.id.prompt();
        });
    });
}

// A tela de login trata o One Tap ela mesma (escolha da conta, cadastro não encontrado).
let _respostaGoogleNaTela = null;
export function aoRespostaGoogle(funcao) {
    _respostaGoogleNaTela = funcao;
}

// Com várias contas ou sem cadastro, a decisão é na tela de login: o retorno do Google vai pela sessão da aba (a tela
// só aceita por poucos minutos), para a pessoa não ter de entrar no Google de novo.
export const CHAVE_GOOGLE_PENDENTE = 'v2-google-pendente';

async function _validarGoogle(resposta) {
    if (_respostaGoogleNaTela) {
        _respostaGoogleNaTela(resposta.credential);
        return;
    }
    // Sem ReturnUrl na query, a volta é a própria página (o v1 levava ao painel e a pessoa perdia a vaga que estava vendo);
    // na home, o Início da conta, como no login.
    const aqui = window.location.pathname + window.location.search;
    const naHome = /^\/([a-z]{2}-[a-z]{2}\/?)?$/i.test(window.location.pathname);
    const volta = new URLSearchParams(window.location.search).get('ReturnUrl') || (naHome ? url('/candidato/painel') : aqui);
    try {
        const retorno = await enviarJson(url('/Login/GoogleLoginValidate'), {
            credential: resposta.credential,
            returnUrl: volta,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        });

        // Antes do Redirect: sem cadastro, o Redirect é o do cadastro e a pessoa ainda não entrou.
        if (retorno.Pessoas || retorno.NaoTemCadastro) {
            try {
                sessionStorage.setItem(CHAVE_GOOGLE_PENDENTE, JSON.stringify({ c: resposta.credential, t: Date.now() }));
            } catch {
                // Sem armazenamento, a tela de login abre no começo.
            }
            window.location.href = url(`/login?ReturnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`);
            return;
        }

        if (retorno.Redirect) {
            avisarLogin('login');
            // A própria página: só recarrega (a vaga aberta volta pelo ?vaga=); uma etapa obrigatória (termos, contato) abre.
            if (retorno.Redirect === aqui) {
                window.location.reload();
            } else {
                window.location.href = retorno.Redirect;
            }
            return;
        }

        // Colaborador cadastrado pelo ID externo só entra no site da empresa dele: o servidor manda o porquê.
        avisarErro(retorno?.Erro === 'ColaboradorNaoAutorizado' && retorno.Mensagem ? retorno.Mensagem : config().textos?.erroGoogle);
    } catch {
        avisarErro(config().textos?.erroGoogle);
    }
}

export function iniciarTerceiros() {
    // Pré-renderizada, a página só chama os terceiros quando aberta: o GA não conta a visita e o One Tap não aparece antes.
    aoExibirPagina(() => {
        const c = config();
        if (c.ga) {
            _ga(c.ga);
        }
        if (c.google?.clientId && c.oneTap) {
            _oneTap(c.google);
        }
    });
}
